const DEFAULT_DASHBOARD_PATH = "/dashboard/dashboard";

const AUTH_AND_PUBLIC_PATH_PREFIXES = [
  "/signin",
  "/signin_code",
  "/signup",
  "/forgotpass",
  "/forgotusername",
  "/reseturpass",
  "/verify-account",
  "/job_report_preview",
  "/task_image_preview",
  "/client/",
  "/signoff-tasks/",
];

const hasUrlScheme = (path = "") => {
  return /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(path);
};

export const isSafeInternalRedirectPath = (path = "") => {
  if (typeof path !== "string") {
    return false;
  }

  if (!path || path.charAt(0) !== "/") {
    return false;
  }

  if (path.indexOf("//") === 0) {
    return false;
  }

  if (hasUrlScheme(path)) {
    return false;
  }

  return true;
};

export const isAuthOrPublicPath = (path = "") => {
  if (!path) {
    return false;
  }

  for (let i = 0; i < AUTH_AND_PUBLIC_PATH_PREFIXES.length; i++) {
    if (path.indexOf(AUTH_AND_PUBLIC_PATH_PREFIXES[i]) === 0) {
      return true;
    }
  }

  return false;
};

export const normalizeToLegacyDashboardPath = (path = "") => {
  if (!isSafeInternalRedirectPath(path)) {
    return DEFAULT_DASHBOARD_PATH;
  }

  if (path === "/") {
    return DEFAULT_DASHBOARD_PATH;
  }

  if (path.indexOf("/dashboard") === 0) {
    return path;
  }

  if (isAuthOrPublicPath(path)) {
    return DEFAULT_DASHBOARD_PATH;
  }

  return "/dashboard" + path;
};

export const resolvePostLoginRedirectPath = (search = "") => {
  const params = new URLSearchParams(search || "");
  const redirectPath = params.get("redirect");
  return normalizeToLegacyDashboardPath(redirectPath || "");
};

export const buildSignInRedirectUrl = (
  pathname = "",
  search = "",
  hash = ""
) => {
  const fullPath = (pathname || "") + (search || "") + (hash || "");

  if (!isSafeInternalRedirectPath(fullPath)) {
    return "/signin";
  }

  return "/signin?redirect=" + encodeURIComponent(fullPath);
};
